(function () {
  'use strict';

  /* @ngdoc object
   * @name payments
   * @description
   *
   */
  angular
    .module('payments', [
      'ui.router'
    ]);
}());
